import { useBreakpoints } from "@/modules/hooks";
import { BREAKPOINTS } from "@/utils";
import { useFormikContext } from "formik";
import styled from "styled-components";
import { spacings } from "../../../../assets/themes";
import { Block, Icon } from "../../../../components";
import FormSelect from "./FormSelect";

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  @media screen and (min-width: ${BREAKPOINTS.md}px) {
    flex-direction: row;
  }
  div:first-child {
    flex: 1;
  }
  div:last-child {
    flex: 1;
  }
`;

const FormFromTo = ({
  options,
  names = ["", ""],
  LeftComponents = [],
  RightComponents = [],
  onChange,
  placeholders = [],
  size,
}) => {
  const { errors, touched } = useFormikContext();
  const breakpoints = useBreakpoints();
  return (
    <StyledWrapper>
      <FormSelect
        size={size}
        error={errors[names[0]] && touched[names[0]]}
        name={names[0]}
        placeholder={placeholders[0]}
        options={options[0]}
        LeftComponent={LeftComponents[0]}
        RightComponent={RightComponents[0]}
        onChange={(value, form) => {
          if (onChange)
            onChange(
              [value, options[1].find((o) => o.value === value)?.value],
              form
            );
        }}
        css={`
          width: 100%;
        `}
      />
      <Block
        marginX={{ xs: 0, md: spacings.m }}
        marginY={{ xs: spacings.m, md: 0 }}
      >
        {breakpoints.get({
          xs: <Icon.Large name="arrow-down" />,
          md: <Icon.Large name="arrow-right" />,
        })}
      </Block>
      <FormSelect
        size={size}
        error={errors[names[1]] && touched[names[1]]}
        name={names[1]}
        placeholder={placeholders[1]}
        options={options[1]}
        LeftComponent={LeftComponents[1]}
        RightComponent={RightComponents[1]}
        onChange={(value, form) => {
          if (onChange)
            onChange(
              [options[0].find((o) => o.value === value)?.value, value],
              form
            );
        }}
        css={`
          width: 100%;
        `}
      />
    </StyledWrapper>
  );
};

export default FormFromTo;
